import { Dispatch, SetStateAction } from "react"
import { Box, Button, Dialog } from "@mui/material"
import { Check as CheckIcon } from "@mui/icons-material"
import { User } from "../../../../redux/user"
import { useAppDispatch } from "../../../../redux/store"
import { OpenTaskWarningModal, Task, TaskLogPayload } from "../types"
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from "../../../../components/Dialog.styled"
import CloseModalButton from "../../../../components/CloseModalButton"
import { addSuccess } from "../../../../redux/alerts"
import * as service from '../service'
import { getPracticeTasks } from "../slice"
import useCustomerNumber from "../../../../hooks/useCustomerNumber"
import { getIsOneTimeTask, getTaskLogPayload } from "../utils/helpers"
import { TaskLogStatus } from "../enums"

type TaskWarningModal = {
  open: boolean,
  tasks: Task[],
  currentUser: User | null,
  setOpenTaskWarningModal: Dispatch<SetStateAction<OpenTaskWarningModal>>
  setSelectedTasks: Dispatch<SetStateAction<Map<number, Task>>>
}

const TaskWarningModal = (props: TaskWarningModal) => {
  const {
    open,
    tasks,
    currentUser,
    setOpenTaskWarningModal,
    setSelectedTasks,
  } = props

  const customerNumber = useCustomerNumber()  

  const dispatch = useAppDispatch()

  const handleClose = () => {
    setOpenTaskWarningModal({ open: false, tasks: null })
  }

  const handleCompleteTasks = async () => {
    if (currentUser) {
      const oneTimeTasks = tasks.filter(task => getIsOneTimeTask(task))

      await Promise.all(
        tasks.map(task => {
          const payload: TaskLogPayload = getTaskLogPayload(task, currentUser, TaskLogStatus.Complete)
          return service.createTaskLog(customerNumber, payload)
        })
      )

      await Promise.all(
        oneTimeTasks.map(task => service.deleteTask(customerNumber, task))
      )

      await dispatch(getPracticeTasks(customerNumber))

      setSelectedTasks(new Map())
      dispatch(addSuccess('Your task has successfully been completed.'))
      handleClose()
    }
  }

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <CloseModalButton handleClose={handleClose} />
        <StyledDialogTitle>
          <Box className="flex flex-align-center" columnGap='4px'>
            <CheckIcon />
            Complete Future Task
          </Box>
        </StyledDialogTitle>
        <StyledDialogContent>
          <Box sx={{ marginBottom: "12px" }}>
            You are completing a task that is due in the future.
          </Box>
          <Box>
            Do you want to proceed?
          </Box>
        </StyledDialogContent>
        <StyledDialogFooter>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button variant="contained" onClick={handleCompleteTasks}>
            Yes
          </Button>
        </StyledDialogFooter>
      </Dialog>
    </>    
  )
}

export default TaskWarningModal
